<template>
  <router-link
    :key="repo.id"
    :to="{ name: repoRouteName, params: { repoId: repo.id}}"
    :class="packageClass"
    :data-automation="`repo-link-${repo.id}`"
  >
    {{ repo.name }}
  </router-link>
</template>

<script>

import { mapState } from 'vuex'
import { REPO_TYPE_R, REPO_TYPE_PYTHON, REPO_TYPE_BIOCONDUCTOR } from '../constants/repo-types'

export default {
  name: 'ReposListItem',
  props: {
    repo: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      currentRepoId: state => state.repos.currentRepoId,
      currentNav: state => state.appFrame.currentNav,
    }),
    repoRouteName: function () {
      switch (this.currentNav) {
        case 'activity':
        case 'overview':
          return this.currentNav

        default:
          return 'packages'
      }
    },
    packageClass: function () {
      let pc = 'menuItem repo'
      if (this.repo.id === this.currentRepoId) {
        pc += ' active'
      }
      switch (this.repo.type) {
        case REPO_TYPE_R:
          pc += ' r'
          break

        case REPO_TYPE_BIOCONDUCTOR:
          pc += ' bioconductor'
          break

        case REPO_TYPE_PYTHON:
          pc += ' python'
          break
      }
      return pc
    },
  },
}

</script>
